import React from 'react';

const TrustIndicators: React.FC = () => {
  const logos = Array(10).fill('LOGO');

  return (
    <section className="w-full bg-[#FDFDFD] border-y border-[#C60302] py-6 relative overflow-hidden font-poppins">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        
        {/* Label As Seen On / Trust Indicators */}
        <h3 className="font-poppins font-semibold text-sm md:text-base text-[#6A6A6A] text-center mb-5 tracking-wide">
          As Seen On/Trust Indicators:
        </h3>

        {/* Logo Strip / Seamless Infinite Marquee */}
        <div className="relative w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
          <div className="flex items-center gap-6 animate-marquee whitespace-nowrap py-1">
            {/* Set 1 */}
            {logos.map((logo, idx) => (
              <div
                key={`logo-1-${idx}`}
                className="flex-shrink-0 w-[133px] h-[62px] border border-[#6A6A6A] rounded-md flex items-center justify-center select-none bg-white/60 hover:border-[#C60302] hover:bg-red-50/20 transition-all duration-300"
              >
                <span className="font-poppins font-semibold text-2xl tracking-wider text-[#6A6A6A] hover:text-[#C60302] transition-colors">
                  {logo}
                </span>
              </div>
            ))}
            {/* Set 2 (for seamless loop) */}
            {logos.map((logo, idx) => (
              <div
                key={`logo-2-${idx}`}
                className="flex-shrink-0 w-[133px] h-[62px] border border-[#6A6A6A] rounded-md flex items-center justify-center select-none bg-white/60 hover:border-[#C60302] hover:bg-red-50/20 transition-all duration-300"
              >
                <span className="font-poppins font-semibold text-2xl tracking-wider text-[#6A6A6A] hover:text-[#C60302] transition-colors">
                  {logo}
                </span>
              </div>
            ))}
          </div>
        </div>

      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default TrustIndicators;
